import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area';
import { cn } from 'cn';
import type { ComponentProps } from 'react';

function ScrollArea({ className, ...props }: ScrollAreaPrimitive.Root.Props) {
  return (
    <ScrollAreaPrimitive.Root
      className={cn('relative min-h-0', className)}
      data-slot="scroll-area"
      {...props}
    />
  );
}

function ScrollAreaViewport({ className, ...props }: ScrollAreaPrimitive.Viewport.Props) {
  return (
    <ScrollAreaPrimitive.Viewport
      className={cn('size-full outline-none', className)}
      data-slot="scroll-area-viewport"
      {...props}
    />
  );
}

function ScrollAreaContent({ className, ...props }: ScrollAreaPrimitive.Content.Props) {
  return (
    <ScrollAreaPrimitive.Content className={className} data-slot="scroll-area-content" {...props} />
  );
}

function ScrollBar({
  className,
  orientation = 'vertical',
  ...props
}: ComponentProps<typeof ScrollAreaPrimitive.Scrollbar>) {
  return (
    <ScrollAreaPrimitive.Scrollbar
      className={cn(
        'z-10 rounded-full opacity-0 transition-opacity duration-200 data-[scrolling]:opacity-100',
        orientation === 'vertical'
          ? 'absolute inset-y-1 right-1 w-1.5'
          : 'absolute inset-x-1 bottom-1 h-1.5',
        className
      )}
      data-slot="scroll-area-scrollbar"
      orientation={orientation}
      {...props}
    >
      <ScrollAreaPrimitive.Thumb
        className="block size-full rounded-full bg-app-border-strong"
        data-slot="scroll-area-thumb"
      />
    </ScrollAreaPrimitive.Scrollbar>
  );
}

export { ScrollArea, ScrollAreaContent, ScrollAreaViewport, ScrollBar };
